import * as moment from 'moment';

/**
 * Normaliza uma data vinda de campos mascarados ou da API para o formato
 * aceito pelo backend, sem depender do parser permissivo do Moment.
 */
export function prepararDataParaApi(value: any): string {
  if (value === null || value === undefined || value === '') return '';

  if (moment.isMoment(value)) {
    return value.isValid() ? value.format('YYYY-MM-DD') : '';
  }

  if (value instanceof Date) {
    const date = moment(value);
    return date.isValid() ? date.format('YYYY-MM-DD') : '';
  }

  const rawValue = String(value).trim();
  if (!rawValue) return '';

  let date = moment(rawValue, ['DDMMYYYY', 'DD/MM/YYYY', 'YYYY-MM-DD'], true);
  if (!date.isValid()) {
    // Preserva o dia informado no ISO, sem deslocá-lo pelo fuso do navegador.
    date = moment.parseZone(rawValue, moment.ISO_8601, true);
  }

  return date.isValid() ? date.format('YYYY-MM-DD') : '';
}

/**
 * Cria uma copia do objeto com os campos de data normalizados para a API.
 * O objeto original permanece intacto para não alimentar máscaras DD/MM/AAAA
 * com valores ISO (por exemplo, 2010-07-26 -> 20/10/0726).
 */
export function prepararCamposData<T extends { [key: string]: any }>(
  source: T,
  fields: string[]
): T {
  const payload: { [key: string]: any } = { ...source };
  fields.forEach(field => {
    payload[field] = prepararDataParaApi(source[field]);
  });
  return payload as T;
}

/**
 * Converte data/hora ISO (UTC) do servidor para horário do Brasil (UTC-3)
 * e formata como DD/MM/YYYY HH:mm:ss.
 * Uso: exibição em telas que devem mostrar horário normalizado para o Brasil.
 * Garante interpretação como UTC (anexa 'Z' se o interceptor tiver removido).
 */
export function formatarDataHoraBR(s: string | null | undefined): string {
  if (!s) return '–';
  try {
    const str = typeof s === 'string' && /T\d{2}:\d{2}/.test(s)
      ? s.replace(/Z$/i, '') + 'Z'
      : s;
    const m = moment.utc(str).subtract(3, 'hours');
    return m.isValid() ? m.format('DD/MM/YYYY HH:mm:ss') : String(s);
  } catch {
    return String(s);
  }
}
